import { render, staticRenderFns } from "./WaggonInfoBody.component.vue?vue&type=template&id=584c0439&"
import script from "./WaggonInfoBody.component.vue?vue&type=script&lang=js&"
export * from "./WaggonInfoBody.component.vue?vue&type=script&lang=js&"
import style0 from "./WaggonInfoBody.component.vue?vue&type=style&index=0&id=584c0439&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports